import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled, createTheme } from '@mui/material/styles';
import {
  Button,
  Container,
  TextField,
  FormControl,
  Grid,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Link,
  Stack,
} from '@mui/material/';
//  import Backdrop from '@mui/material/Backdrop';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import Backdrop from '@mui/material/Backdrop';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import userSignup from '../../utils/apis/user/userSignup';
import signupEmailAuthCodeVerify from '../../utils/apis/user/singupEmailAuthCodeVerify';
import signupEmailVerify from '../../utils/apis/user/signupEmailVerify';
import TermsOfUseModal from '../../components/ModalComponent/TermsOfUseModal';
import PrivacyPolicy from '../../components/ModalComponent/PrivacyPolicy';
import SignupInviteModal from './SignupInviteModal';
import PasswordInput from '../../components/common/PasswordInput';
// ------------------------------------------------------- Styled Custom Component

const Alert = React.forwardRef((props, ref) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

const StyledBtn = styled('button')(() => ({
  marginLeft: '10px',
  width: '120px',
  backgroundColor: `#222`,
  border: `solid 1px #222`,
  borderRadius: '5px',
  color: 'white',
  fontSize: 'medium',
  fontWeight: '500',
  cursor: 'pointer',
}));

const StyledLoadingButton = styled(LoadingButton)({
  height: '56px',
  whiteSpace: 'nowrap',
  fontWeight: 600,
  width: '90px',
  marginLeft: '5px',
});

const PasswordText = styled('p')({
  position: 'absolute',
  right: '16px',
  top: '50%',
});

// ------------------------------------------------------- Styled Custom Component END

// ------------------------------------------------------- 기타 함수 선언

const SignupForm = () => {
  // --------------------------------------------------------- useState 선언
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const navigate = useNavigate();

  // User Email 입력 및 이메일 전송 처리 (정규식 추가예정) 23/02/02 cheol-ha
  const [userInputEmail, setUserInputEmail] = useState('');
  const [userEmailchecked, setUserEmailChecked] = useState(false);
  const [emailSendLoading, setEmailSendLoading] = useState(false);
  const [emailSendBtn, setEmailSendBtn] = useState('인증');

  const [inviteToken, setInviteToken] = useState('');
  const [inviteOrgName, setInviteOrgName] = useState('');

  // 인증번호 입력 및 검증 처리
  const [AuthBtn, setAuthBtn] = useState(0);
  const [emailInput, setEmailInput] = useState(false);
  const [authBtnString, setAuthBtnString] = useState('확인');
  const [authLoading, setAuthLoading] = useState(false);

  // Email
  const [Email, setEmail] = useState('');
  const [checked, setChecked] = useState(false);

  const [InputAuth, setInputAuth] = useState('');

  const [inputPW, setInputPW] = useState('');
  const [reInputPW, setReInputPW] = useState('');
  const [pwCheck, setPwCheck] = useState(false);
  const [regExp, setRegExp] = useState(false);

  // 동의 체크 ----------------------------------------------------------
  const [usePolicy, setUsePolicy] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);

  // ################################# 이벤트 핸들러 Start ####################################

  // 이메일 입력
  const handleInputEmail = (e) => {
    setUserInputEmail(e.target.value);
  };

  // 이메일 인증 클릭
  const ClickHandler = () => {
    if (userEmailchecked) {
      // 재인증 눌렀을 때
      setAuthBtn(0); // 인증코드 입력창 비활성화
      setUserEmailChecked(false); // 이메일 입력창 활성화
      sessionStorage.setItem('AuthCode', null); // 인증코드 삭제
      setEmailSendBtn(t('인증')); // 버튼 명 변경
      setEmailChk(false);
    } else {
      setEmailInput(true);
      // setLoading(true);
      if (userInputEmail !== '') {
        signupEmailVerify({ email: userInputEmail })
          .then((response) => {
            setEmailSendLoading(true);
            // console.log(response);

            setUserEmailChecked(true); // 이메일 입력창 비활성화
            setAuthBtn(1); // 인증코드 입력창 활성화

            setEmailSendBtn(t('재인증')); // 버튼 명 변경
            alert(t('인증번호가 발송되었습니다.'));
            setEmailSendLoading(false);
          })
          .catch(({ response }) => {
            const { status } = response;
            if (status === 400) alert(t('이메일 형식이 올바르지 않습니다.'));
            else alert(t('이미 등록된 이메일입니다.'));
            setEmailSendLoading(false);
          });
      } else {
        alert(t('이메일을 입력해주세요!'));
      }
    }
  }; // 이메일 인증버튼 클릭 핸들러 END

  // 인증번호 검사
  const CheckAuthNum = () => {
    signupEmailAuthCodeVerify({
      email: userInputEmail,
      authCode: InputAuth,
    })
      .then(() => {
        setEmailChk(true);
        alert(t('이메일 인증이 완료되었습니다.'));
      })
      .catch(({ response }) => {
        const { statusCode } = response.data;
        if (statusCode === 401) alert(t('인증번호가 일치하지 않습니다.'));
        else alert('SERVER_ERROR');
      });
  };

  const AuthOnChange = (e) => {
    setInputAuth(e.target.value);
  };

  // 비밀번호 입력 핸들러
  const handleInputPW = (e) => {
    if (e.target.id === 'password') {
      setInputPW(e.target.value); // 비밀번호 입력
      const regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/;
      setRegExp(regExp.test(e.target.value)); // 정규식 체크
    } else if (e.target.id === 'rePassword') {
      setReInputPW(e.target.value); // 입력
      if (inputPW === e.target.value) {
        // 일치 확인
        setPwCheck(true);
      } else {
        setPwCheck(false);
      }
    }
  };

  // 약관동의 이벤트 핸들러
  const handleAgree1 = (e) => {
    console.log(e.target.checked, e.target.name);

    if (e.target.checked) {
      setUsePolicy(true);
    } else {
      setUsePolicy(false);
    }
  };

  const handleAgree2 = (e) => {
    // console.log(e.target.checked);
    if (e.target.checked) {
      setPrivacyPolicy(true);
    } else {
      setPrivacyPolicy(false);
    }
  };

  // 이름, 닉네임 입력 --------------------------------------------------
  const [inputName, setInputName] = useState('');
  const [inputComp, setInputComp] = useState('');

  const InputHandler = (e) => {
    // console.log(e.target.id, e.target.value);
    if (e.target.id === 'name') {
      setInputName(e.target.value);
    } else {
      setInputComp(e.target.value);
    }
  };

  // 이전, 다음 버튼 ---------------------------------------------------
  const [page, setPage] = useState([1, t('회원가입'), t('다음')]);
  const [divSign, setDivSign] = useState('');
  const [divInfor, setDivInfor] = useState('none');

  // 이메일 인증이 완료되면 EmailChk 변수 true로
  const [EmailChk, setEmailChk] = useState(false);

  const NextPage = () => {
    if (pwCheck && regExp && EmailChk) {
      // 비밀번호 일치할 때
      setPage([2, t('정보입력'), t('완료')]);
      setDivSign('none');
      setDivInfor('');
    } else if (!EmailChk) {
      alert('이메일 인증이 완료되지 않았습니다.');
    } else if (!regExp) {
      alert(t('사용할 수 없는 비밀번호입니다.'));
    } else if (!pwCheck) {
      alert(t('비밀번호가 일치하지 않습니다.'));
    }
  };

  // 회원가입 완료 버튼 ------------------------------------------------

  const SubmitInfo = () => {
    if (inputName === '') {
      alert(t('이름을 입력해 주세요.'));
    } else if (inputComp === '') {
      alert(t('회사명을 입력해 주세요.'));
    } else if (!usePolicy) {
      alert(t('이용약관에 동의해 주세요.'));
    }
    if (!privacyPolicy) {
      alert(t('개인정보취급방침에 동의해 주세요.'));
    } else if (inputName !== '' && inputComp !== '' && usePolicy && privacyPolicy) {
      const sendData = {
        email: userInputEmail,
        password: inputPW,
        name: inputName,
        company_name: inputComp,
        inviteUser: inviteToken,
        countryCode: selectedCountryCode,
        authCode: InputAuth,
      };

      // // console.log('sendData', sendData);

      userSignup(sendData)
        .then((response) => {
          console.log('response', response.data);
          alert(t('회원가입이 완료되었습니다.'));
          navigate('/login', { replace: true });
        })
        .catch(({ response }) => {
          const { status } = response;
          if (status === 409) {
            alert(t('이미 가입된 이메일 입니다.'));
          } else if (status === 401) {
            alert(t('인증코드가 올바르지 않습니다 다시 가입을 진행 해주세요.'));
          } else if (status === 400) {
            alert(t('형식이 올바르지 않습니다'));
          }
        });
    }
  };

  const [termsModalOpen, setTermsModalOpen] = React.useState(false);
  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = React.useState(false);

  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('Republic of Korea');
  const [selectedCountryCode, setSelectedCountryCode] = useState(156);

  const termsHandleOpen = () => {
    setTermsModalOpen(true);
  };
  const termsHandleClose = () => {
    setTermsModalOpen(false);
  };

  const privacyPolicyHandleOpen = () => {
    setPrivacyPolicyModalOpen(true);
  };
  const privacyPolicyHandleClose = () => {
    setPrivacyPolicyModalOpen(false);
  };

  const handleCountryChange = (event) => {
    setSelectedCountryCode(event.target.value);
    // console.log(event.target);
    // setSelectedCountryCode()
  };

  const [open, setOpen] = React.useState(false);
  const [backLoadingOpen, setBackLoadingOpen] = React.useState(false);
  const [signupInviteToken, setSignupInviteToken] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const inviteToken = params.get('invite_token');
    // setOrgId(orgId);

    if (inviteToken !== '' && inviteToken !== null) {
      setBackLoadingOpen(true);
      const getOrgName = async () => {
        try {
          const response = await axios({
            url: `${process.env.REACT_APP_SERVER_URL}/user/org-name/${inviteToken}`,
            method: 'post',
          });
          console.log('data', response.data[0][0].name);
          setInviteOrgName(response.data[0][0].name);
          setInviteToken(inviteToken);
          setSignupInviteToken(`?invite_token=${inviteToken}`);
          setOpen(true);
        } catch (error) {
          console.log('error', error);
        }
      };
      getOrgName();
      setBackLoadingOpen(false);
    }

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/user/country`)
      .then((response) => {
        console.log('country list', response.data);
        setCountryList(response.data);
      })
      .catch((response) => {
        console.log(response);
      });
  }, [window.location]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <Typography component="h1" variant="h3" style={{ marginBottom: '48px' }}>
          {page[1]}
        </Typography>
        <Box noValidate style={{ display: divSign }}>
          <FormControl component="fieldset" variant="standard">
            <Grid container spacing={2}>
              <Grid item xs={12} style={{ marginBottom: '10px' }}>
                <Grid item xs={12} style={{ display: 'flex' }}>
                  <TextField
                    required
                    autoFocus
                    fullWidth
                    type="email"
                    id="email"
                    name="email"
                    label={t('이메일(아이디)')}
                    onChange={handleInputEmail}
                    style={{ minWidth: '294px' }}
                    disabled={userEmailchecked}
                  />
                  {/* <StyledBtn onClick={ClickHandler} disabled={EmailChk[0]}>인증</StyledBtn> */}
                  <StyledLoadingButton
                    onClick={ClickHandler}
                    endIcon={!userEmailchecked ? <SendIcon /> : <></>}
                    // endIcon={<SendIcon />}
                    loading={emailSendLoading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    <span>{t(emailSendBtn)}</span>
                  </StyledLoadingButton>
                </Grid>
                {AuthBtn === 1 ? (
                  <Grid item xs={12} style={{ display: 'flex', marginTop: '16px' }}>
                    <TextField
                      required
                      autoFocus
                      fullWidth
                      id="authCode"
                      name="authCode"
                      label={t('인증번호 입력')}
                      onChange={AuthOnChange}
                      disabled={EmailChk}
                    />
                    {/* <StyledBtn onClick={CheckAuthNum} disabled={EmailChk[0]}>완료</StyledBtn> */}
                    <StyledLoadingButton
                      onClick={CheckAuthNum}
                      endIcon={!EmailChk ? <></> : <CheckCircleRoundedIcon />}
                      loading={authLoading}
                      loadingPosition="end"
                      variant="contained"
                      disabled={EmailChk}
                    >
                      <span>{t(authBtnString)}</span>
                    </StyledLoadingButton>
                  </Grid>
                ) : null}
              </Grid>
              <PasswordInput
                passwordLabel={t('비밀번호')}
                rePasswordLabel={t('비밀번호 확인')}
                onChange={handleInputPW}
                regExp={regExp}
                regExp2={pwCheck}
                password={inputPW}
                rePassword={reInputPW}
                onChangePassword={handleInputPW}
                changeButtonText={t('비밀번호 변경')}
              />
              {/* <Grid item xs={12} style={{ position: 'relative', marginTop: '20px' }}>
                <TextField
                  required
                  fullWidth
                  type="password"
                  id="password"
                  name="password"
                  label={t('비밀번호')}
                  // onChange={handleInputPW}
                  onKeyUp={handleInputPW}
                />
                {!regExp && inputPW !== '' ? (
                  <PasswordText style={{ fontSize: 'smaller', color: 'red' }}>
                    {t('8자 이상 영문, 숫자, 특수문자가 조합되어야합니다.')}
                  </PasswordText>
                ) : null}
                {regExp && inputPW !== '' ? (
                  <PasswordText style={{ fontSize: 'smaller', color: 'blue' }}>
                    {t('사용가능한 비밀번호 입니다.')}{' '}
                  </PasswordText>
                ) : null}
              </Grid>

              <Grid item xs={12} style={{ position: 'relative' }}>
                <TextField
                  required
                  fullWidth
                  type="password"
                  id="rePassword"
                  name="rePassword"
                  label={t('비밀번호 확인')}
                  onChange={handleInputPW}
                />
                {!pwCheck && reInputPW !== '' ? (
                  <PasswordText style={{ fontSize: 'smaller', color: 'red' }}>
                    {t('비밀번호가 일치하지 않습니다.')}
                  </PasswordText>
                ) : null}
                {pwCheck && reInputPW !== '' ? (
                  <PasswordText style={{ fontSize: 'smaller', color: 'blue' }}>
                    {t('비밀번호가 일치합니다.')}
                  </PasswordText>
                ) : null} */}

              {/* {!regExp && asdas && <p style={{ fontSize: 'smaller', color: 'blue' }}>8 ~ 16자 사이 영문, 숫자가 조합되어야합니다.</p>} */}
              {/* </Grid> */}
            </Grid>
          </FormControl>
        </Box>

        <div style={{ display: divInfor }}>
          <div>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="name"
                name="name"
                label={t('이름을 입력하세요.')}
                value={inputName}
                onChange={InputHandler}
              />
            </Grid>
            <Grid item xs={12} style={{ marginBottom: '100px', marginTop: '16px' }}>
              <TextField
                required
                fullWidth
                id="nickname"
                name="name"
                label={t('닉네임(회사명)을 입력하세요.')}
                value={inputComp}
                onChange={InputHandler}
              />
            </Grid>
            <Select value={selectedCountryCode} onChange={handleCountryChange}>
              {countryList.map((row, index) => (
                <MenuItem key={index} value={row.country_code}>
                  {row.full_name}
                </MenuItem>
              ))}
            </Select>
          </div>
          <Grid item xs={12}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <FormControlLabel
                control={<Checkbox name="aggre1" onChange={handleAgree1} color="primary" id="UsingPolicy" />}
                label={t('이용약관에 동의합니다.(필수)')}
              />
              <Link target="_blank" onClick={termsHandleOpen}>
                {t('이용약관')}
              </Link>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <FormControlLabel
                control={<Checkbox onChange={handleAgree2} color="primary" id="PrivacyPolicy" />}
                label={t('개인정보취급방침에 동의합니다.(필수)')}
              />
              <Link target="_blank" onClick={privacyPolicyHandleOpen}>
                {t('개인정보취급방침')}
              </Link>
            </div>
          </Grid>
        </div>
        <div style={{ display: 'flex', width: '-webkit-fill-available', alignItems: 'flex-end', flex: 1 }}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            size="large"
            style={{
              width: '240px',
              marginRight: '10px',
              boxShadow: 'none',
              color: 'black',
              backgroundColor: 'white',
              border: 'solid 1px #ddd',
            }}
            onClick={() => {
              if (page[0] === 2) {
                setPage([1, t('회원가입'), t('다음')]);
                setDivSign('');
                setDivInfor('none');
              } else {
                navigate(`/login${signupInviteToken}`, { replace: true });
              }
            }}
          >
            {t('이전')}
          </Button>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            size="large"
            style={{ boxShadow: 'none', backgroundColor: '#1a9ef8' }}
            onClick={() => {
              if (page[0] === 1) {
                NextPage();
              } else if (page[0] === 2) {
                SubmitInfo();
              }
            }}
          >
            {page[2]}
          </Button>
        </div>
      </Box>

      {open && (
        <SignupInviteModal
          inviteOrgName={inviteOrgName}
          titleText={t('초대 전용 링크입니다')}
          bodyText={t('회원가입을 진행해주세요.')}
        />
      )}

      <TermsOfUseModal modalOpen={termsModalOpen} handleClose={termsHandleClose} />
      <PrivacyPolicy modalOpen={privacyPolicyModalOpen} handleClose={privacyPolicyHandleClose} />
    </>
  );
};

export default SignupForm;
